import type { StaffMember } from '../../../../api/staff';
import { Avatar } from '../../primitives';

import { memberName } from './crewModel';

export function CrewPickerResultRow({
  member,
  onPick,
  regionTag,
}: {
  member: StaffMember;
  onPick: (member: { userId: string; name: string }) => void;
  regionTag: string | null;
}) {
  const name = memberName(member);
  return (
    <button
      type="button"
      onClick={() => onPick({ userId: member.id, name })}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        padding: '6px 8px',
        borderRadius: 8,
        border: '1px solid transparent',
        background: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        color: 'var(--nb-ink)',
        font: 'inherit',
      }}
    >
      <Avatar name={name} size={24} />
      <span style={{ fontSize: 13, flex: 1 }}>{name}</span>
      {regionTag && (
        <span
          className="nb-eyebrow"
          style={{ fontSize: 9.5, color: 'var(--nb-warn)', flexShrink: 0 }}
        >
          {regionTag}
        </span>
      )}
    </button>
  );
}
